import type { OnboardingOnboardingAnswers } from '@customerio/hydra-ui-api';
import { isEmptyString } from '@/utils/string';

const hasListenTargets = (answers: OnboardingOnboardingAnswers | undefined): boolean =>
  (answers?.listen_targets?.length ?? 0) > 0;

/**
 * Whether the user finished the wizard's question set. Routing treats an
 * answered user as done with `/onboarding`, so this must not read true
 * mid-conversation: a legacy `listen_targets` answer alone must not strand a
 * user who never saw the earlier questions with no route back into the chat.
 */
export function hasAnsweredOnboarding(answers: OnboardingOnboardingAnswers | undefined): boolean {
  return (
    !isEmptyString(answers?.goal) &&
    answers?.starting_point != null &&
    hasListenTargets(answers) &&
    (answers.channels?.length ?? 0) > 0
  );
}
